<script setup lang="ts">
/**
 * /how-long-should-a-resume-be — the guide for the resume length cluster: how
 * long, one page or two, can it be two, how to fit it on one, how far back to
 * go.
 *
 * Carved out of /how-to-write-a-resume, which keeps a one-paragraph answer in
 * its FAQ and its last step and links here for the rest. The blog article on
 * the same question redirects here (constants/blogRedirects.ts).
 *
 * Carries FAQPage only. The page is a decision plus a cutting order, not one
 * procedure, so it does not get a HowTo (see useJsonLd).
 */
const { t } = useI18n()
const { faqPageNode } = useJsonLd()

definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/jak-dlouhy-ma-byt-zivotopis', de: '/wie-lang-sollte-ein-lebenslauf-sein', pl: '/jak-dlugie-powinno-byc-cv' } })

/** Answered in prose on the page, and mirrored into FAQPage structured data. */
const FAQ_IDS = ['onePage', 'jobs', 'ats','half', 'font', 'student', 'pageTwo', 'coverLetter'] as const

const faqItems = computed(() =>
  FAQ_IDS.map(id => ({
    id,
    question: t(`resumeLengthGuide.faq.${id}.q`),
    answer: t(`resumeLengthGuide.faq.${id}.a`),
  })),
)

const extraNodes = computed(() => [
  faqPageNode('/how-long-should-a-resume-be', faqItems.value),
])
</script>

<template>
  <MarketingFeaturePage
    seo-key="resumeLength"
    path="/how-long-should-a-resume-be"
    :breadcrumb-title="t('resumeLengthGuide.heading')"
    :extra-nodes="extraNodes"
  >
    <MarketingResumeLengthGuide />

    <MarketingFaqSection
      :title="t('resumeLengthGuide.faq.title')"
      :items="faqItems"
      name="resume-length-faq"
    />
  </MarketingFeaturePage>
</template>
